import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import en from './locales/en.json';
import fr from './locales/fr.json';
import de from './locales/de.json';
import it from './locales/it.json';
import pt from './locales/pt.json';
import es from './locales/es.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: { en: { translation: en }, fr: { translation: fr }, de: { translation: de }, it: { translation: it }, pt: { translation: pt }, es: { translation: es } },
    fallbackLng: 'de',
    interpolation: { escapeValue: false },
    detection: { order: ['path', 'localStorage', 'navigator'], lookupFromPathIndex: 0, caches: ['localStorage'] },
  });

export default i18n;
